import { createFileRoute } from '@tanstack/react-router';
import { OverviewPage } from '@/pages/OverviewPage';

export const Route = createFileRoute('/_authed/overview')({
  component: OverviewPage,
});
